export enum QUERY_KEYS {
  getRequests = "LABORATORY_REQUESTS_GET",
  getExperimentParameters = "EXPERIMENT_PARAMETERS_GET",
  sendRequest = "SAMPLING_EXPERIMENT_REQUEST_POST",
  getReportsLaboratory = "GET_REPORTS_LABORATORY",
  getMarkAsRead = "MARK_AS_READ_GET",
  sendCostCalculationRequest = "COST_CALCULATION_POST",
  sendLaboratoriesList = "LABORATORIES_LIST_POST",
  getInformationExperts = "INFORMATION_EXPERTS_GET",
}

export enum PARAMETERS_CATEGORY {
  water = 1,
  soil = 2,
  plant = 4
}

export enum PARAMETERS_TYPE {
  agriculturalWater = 1,
  fisheriesWater = 2,
  drinkingWater = 3,
  agriculturalSoil = 4,
  plant = 6
}

